import type { User } from '@/gen/customer/management/v1/service_pb'

import { AuthorLine } from '@/components/lemmala-design-system/author-line/author-line'

type AssessmentUserRowProps = {
  users: (User | undefined)[]
  // Name text style, passed through to AuthorLine. Defaults to the body ramp.
  textClassName?: string
}

// Avatar + name for each usable user in an assessment details pane row.
export const AssessmentUserRow = ({
  users,
  textClassName = 'text-body-small',
}: AssessmentUserRowProps) => {
  const visible = users.filter((user): user is User => !!(user?.name || user?.email))
  if (visible.length === 0) return null

  return (
    <div className='flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1'>
      {visible.map((user) => (
        <AuthorLine
          key={user.id}
          name={user.name || user.email}
          avatarUrl={user.avatarUrl}
          textClassName={textClassName}
          className='min-w-0'
        />
      ))}
    </div>
  )
}
